import React from 'react'
import { graphql } from 'gatsby'
import Container from '@atoms/Container'
import paddingDefault from '@utils/paddingDefault'
import { colors } from '../primitives/colors'

const Testimonial = ({ data }) => {
  const { author_name, author_company, quote } = data

  return (
    <div css={[paddingDefault(), styles.background]}>
      <Container>
        <div css={styles.testimonialOuterWrap}>
          <div css={styles.testimonialInnerWrap}>
            <p css={styles.author}>{author_name}</p>
            <p css={styles.company}>{author_company}</p>
            <p css={styles.quote}>{quote}</p>
          </div>
        </div>
      </Container>
    </div>
  )
};

const styles = {
  background: {
    backgroundColor: colors.grey100
  },
  author: {
    marginBottom: "0.25rem",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    letterSpacing: "0.1em"
  },
  company: {
    marginBottom: "0.75rem",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    fontWeight: 300,
    letterSpacing: "0.1em"
  },
  quote: {
    color: colors.primaryOrange, 
    fontSize: "26px",
    lineHeight: 1.375,
    "@media (min-width: 1024px)": {
      fontSize: "32px",
    }
  },
  testimonialOuterWrap: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "@media (min-width: 1024px)": {
      flexDirection: "row"
    }
  },
  testimonialInnerWrap: {
    marginBottom: "2rem",
    "@media (min-width: 1024px)": {
      paddingTop: "1rem",
      paddingLeft: "1.75rem",
      marginBottom: "0",
      marginRight: "5rem",
      width: "66.666667%"
    }
  }
};

export const query = graphql`
  fragment TestimonialData on CmsPageBuilderBlocks {
    testimonial {
      author_name
      author_company
      quote
    }
  }
`;

export default Testimonial;
